<template>
  <div class="ringAnalysis mainPageBg">
    <div class="leftMenuBox">
      <RingAnalysisTree @getTreeActive="getTreeActive" />
    </div>
    <div class="rightBox">
      <div class="cardBox">
        <CardListCom :cardList="cardList" />
      </div>
      <div class="tableBox ashComWrap">
        <div style="text-align: right">
          <el-button
            type="primary"
            size="mini"
            plain
            style="margin: 10px"
            :disabled="!authority"
            @click="exportExcel"
            ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
          >
        </div>
        <div class="tabBox">
          <el-table
            :data="tableData"
            border
            height="100%"
            style="width: 100%"
            :header-cell-style="{
              'font-weight': 'bold',
              color: '#333',
            }"
            size="small"
          >
            <el-table-column
              v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              align="center"
              :formatter="$setTabNumber"
            ></el-table-column>
            <el-table-column
              v-if="tableData.length"
              label="图表"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="20%;"
    >
      <div style="width: 90%; height: 300px">
        <PublicEcharts
          id="'id1'"
          :chartsData="chartsData"
          :type="'lightSwitchable'"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import {
  judgeAuthority,
  exportExcelFun,
  matchingECNameUnit,
} from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import PublicEcharts from "@/components/PublicEcharts.vue";
import CardListCom from "@/components/DevOps/CardListCom.vue";
import { handleExportAuthority } from "@/assets/utils/handleData.js";
import RingAnalysisTree from "@/components/nengyuanguanli/ECAnalysis/RingAnalysisTree.vue";
export default {
  components: {
    RingAnalysisTree,
    PublicEcharts,
    CardListCom,
  },
  data() {
    return {
      authority: false,
      cardList: [],
      tableData: [],
      tabHead: [],
      dialogVisible: false,
      chartsData: {
        type: "bar",
        unit: "",
        showChange: true,
        xData: [],
        dataArr: [],
      },
      activeItem: {},
    };
  },
  methods: {
    handleEdit(index, row) {
      this.chartsData.xData = [this.activeItem.date];
      this.chartsData.dataArr = [];
      this.chartsData.unit = matchingECNameUnit(
        this.activeItem.activeType,
        "unit"
      );
      this.dialogTitle =
        row.entityName +
        matchingECNameUnit(this.activeItem.activeType, "title") +
        "图表分析";
      this.dialogVisible = true;
      setTimeout(() => {
        this.chartsData.xData = [this.activeItem.date];
        this.chartsData.dataArr = [
          { name: "当期", data: [row.nowValue] },
          { name: "上期", data: [row.beforeValue] },
        ];
      }, 20);
    },
    getTreeActive(data) {
      this.activeItem = data;
      this.getData();
    },
    getData() {
      this.$store.commit("SET_LOADING", true);
      this.getRingAnalysis();
      this.getRingTable();
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },

    async getRingAnalysis() {
      this.cardList = [];
      let res = await api.energyRingAnalysis({
        assetIds: this.activeItem.assetId.join(","),
        data: this.activeItem.date,
        type: this.activeItem.type,
        energyType: this.activeItem.activeType,
      });
      if (res && res.data.code == 200) {
        this.cardList = res.data.data;
        this.cardList.map((v) => {
          v.name += " " + v.unit ?? "";
        });
      }
    },
    async getRingTable() {
      this.tabHead = [];
      this.tableData = [];

      let unit = matchingECNameUnit(this.activeItem.activeType, "unit");
      let title = matchingECNameUnit(this.activeItem.activeType, "title");
      this.tabHead = [
        { label: "设备区域名称", prop: "entityName" },
        {
          label:
            this.activeItem.type == "YEAR"
              ? "本年" + title + unit
              : this.activeItem.type == "MONTH"
              ? "本月" + title + unit
              : "当日" + title + unit,
          prop: "nowValue",
        },
        {
          label:
            this.activeItem.type == "YEAR"
              ? "去年" + title + unit
              : this.activeItem.type == "MONTH"
              ? "上月" + title + unit
              : "昨日" + title + unit,
          prop: "beforeValue",
        },
        { label: "变化值", prop: "changeValue" },
        { label: "环比%", prop: "monthOnMonth" },
      ];
      let res = await api.energyRingTable({
        assetIds: this.activeItem.assetId.join(","),
        data: this.activeItem.date,
        type: this.activeItem.type,
        energyType: this.activeItem.activeType,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
      }
    },
    exportExcel() {
      exportFile.xlsxFile(
        XLSX,
        `环比${matchingECNameUnit(this.activeItem.activeType, "title")}分析-${
          this.activeItem.date
        }`,
        {
          excel: exportExcelFun(this.tabHead, this.tableData),
        }
      );
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
  },
};
</script>

<style lang="scss" scoped>
.ringAnalysis {
  @include setFlexBetween;
  .leftMenuBox {
    @include setMenuWH;
  }
  .rightBox {
    // @include setCenterWH;
    width: calc(79% - 12px);
    height: 100%;
    .timeBox {
      height: 60px;
      width: 100%;
      background: #fff;
      @include setFlexStart;
    }
    .cardBox {
      width: 100%;
      height: 110px;
      margin: 12px 0;
      background: #fff;
      border-radius: 12px;
    }
    .tableBox {
      width: 100%;
      height: calc(100% - 134px);
      .tabBox {
        width: 98%;
        height: 89%;
        margin: 0 auto;
      }
    }
  }
}
</style>
